import React from 'react';
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './store';
import MasterLayout from './layout/main';
import { LanguageProvider } from './localization/LanguageContainers';
import { QueryClient, QueryClientProvider } from 'react-query'; 
import 'antd/dist/antd.css';
import './App.css';

const { store, persistor } = configureStore();
const queryClient = new QueryClient();

const App = () => {
  return (
    <LanguageProvider>      
      <div className="App">
        <Provider store={store}>    
          <QueryClientProvider client={queryClient}>
            <PersistGate loading={null} persistor={persistor}>
              <Router>
                <MasterLayout />
              </Router>
            </PersistGate>      
          </QueryClientProvider>   
        </Provider>
      </div>
    </LanguageProvider>
  );
}
export default App;
